import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import Hero from "@/pages/home/components/Hero";
import Services from "@/pages/home/components/Services";
import Plans from "@/pages/home/components/Plans";
import WhyNxhost from "@/pages/home/components/WhyNxhost";
import Performance from "@/pages/home/components/Performance";
import BusinessSolutions from "@/pages/home/components/BusinessSolutions";
import SiteCreation from "@/pages/home/components/SiteCreation";
import SpeedComparison from "@/components/feature/SpeedComparison";
import DemoBanner from "@/components/feature/DemoBanner";
import OnlineStores from "@/pages/home/components/OnlineStores";
import VpsServers from "@/pages/home/components/VpsServers";
import ResellerProgram from "@/pages/home/components/ResellerProgram";
import HelpCta from "@/pages/home/components/HelpCta";
import Timeline from "@/pages/home/components/Timeline";
import Testimonials from "@/pages/home/components/Testimonials";
import Faq from "@/pages/home/components/Faq";
import FinalCta from "@/pages/home/components/FinalCta";
import { faqs, hostingPlans } from "@/mocks/home";
import { PLAN_IMAGE_HOSTING } from "@/constants/site";

export default function Home() {
  const { hash, key } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    let tries = 0;
    let timer = 0;

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (tries < 25) {
        tries += 1;
        timer = window.setTimeout(tryScroll, 60);
      }
    };

    timer = window.setTimeout(tryScroll, 60);
    return () => window.clearTimeout(timer);
  }, [hash, key]);

  return (
    <SiteLayout>
      <Seo
        title="NXHOST | Hospedagem, Sites, VPS e Soluções Digitais"
        description="Hospedagem de sites, domínios, VPS, servidores, criação de sites, lojas virtuais e sistemas web para empresas. Conheça a NXHOST e tenha uma infraestrutura digital à altura do seu negócio."
        keywords="hospedagem de sites, VPS, servidores, registro de domínio, criação de sites, lojas virtuais, sistemas web, sites multi-idiomas"
        path="/"
        titleEn="NXHOST | Hosting, Websites, VPS and Digital Solutions"
        titleEs="NXHOST | Hosting, Sitios Web, VPS y Soluciones Digitales"
        descriptionEn="Web hosting, domains, VPS, servers, website creation, online stores and web systems for companies. Get fast, secure and professional digital infrastructure with NXHOST."
        descriptionEs="Hosting web, dominios, VPS, servidores, creación de sitios web, tiendas online y sistemas web para empresas. Infraestructura digital rápida, segura y profesional con NXHOST."
        plans={hostingPlans.map((plan) => ({
          name: plan.name,
          price: plan.price,
          url: plan.url,
          image: PLAN_IMAGE_HOSTING,
          category: "Hospedagem de sites",
        }))}
        faqs={faqs}
      />
      <Hero />
      <Services />
      <Plans />
      <WhyNxhost />
      <Performance />
      <BusinessSolutions />
      <SiteCreation />
      <SpeedComparison />
      <DemoBanner />
      <OnlineStores />
      <VpsServers />
      <ResellerProgram />
      <HelpCta />
      <Timeline />
      <Testimonials />
      <Faq />
      <FinalCta />
    </SiteLayout>
  );
}